// extracted by mini-css-extract-plugin
export default {"filter":"filter-Jmpk8"};